import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { RootLayout } from 'modules/layout';
import { AppBase } from 'modules/layout/AppBase/AppBase';

import { AuthAddressContext, UserData } from './Context/Context';
import useNetwork from './hooks/use-network';
import { GlobalDialogs } from './components';
import { NETWORK } from './types';

Sentry.init({
  dsn: 'https://31b5bc1be356d94fe0a2eee1fce932ba@o4508735084691456.ingest.de.sentry.io/4508931121676368',
});

export const App = () => {
  const [, , setNetwork] = useNetwork();
  const [authDataStore] = useState<UserData | null>(null);

  // TODO_R: перенести в отдельный кастомный кастомный хук с названием syncNetworkStorage в файл src/hooks/use-network.ts вместе с useNetwork
  useEffect(() => {
    // setNetwork((localStorage.getItem('network') || 'testnet') as NETWORK)
    setNetwork((localStorage.getItem('network') || 'mainnet') as NETWORK);
  }, []);

  return (
    <AuthAddressContext.Provider value={authDataStore || null}>
      <Suspense fallback={null}>
        <AppBase>
          <Router>
            <Switch>
              <Route strict path="/" component={RootLayout} />
            </Switch>
          </Router>
          <GlobalDialogs />
        </AppBase>
      </Suspense>
    </AuthAddressContext.Provider>
  );
};
